if (typeof boostPFSThemeConfig !== 'undefined') {
	// Override Settings
	var boostPFSFilterConfig = {
		general: {
			limit: 20,
			// Optional
			//loadProductFirst: true,
			styleScrollToTop: 'style2',
			removePriceDecimal: true,
			filterTreeMobileStyle: 'style1',
			requestInstantly: true,
			swatchStyle: 'square-grid',
			showSingleOption: false,
			showOutOfStockOption: true,
		},
		label: {
			from: 'From'
		}
	};
}

var boostPFSTemplate = {

	'soldOutClass': 'product-price--sold-out grid-view-item--sold-out',
	'onSaleClass': 'on-sale',

	'oneImage': '<div class="grid-view-item-image-wrapper">' +
		'<a class="grid-view-item-image-link" href="{{itemUrl}}" title="View {{itemTitle}} Details"><img class="grid-view-item-image" src="{{itemThumbUrl}}" alt="{{itemTitle}}"></a>' +
		'</div>',

	'multiImagesWrapper': '<div class="swiper">' +
		'<div class="swiper-wrapper">' +
		'{{multiImages}}' +
		'</div>' +
		'<div class="swiper-button-prev"></div>' +
		'<div class="swiper-button-next"></div>' +
		'</div>',
	'multiImagesItem': '<div class="swiper-slide">' +
		'<a class="grid-view-item-image-link" href="{{itemUrl}}" title="View {{itemTitle}} Details"><img class="grid-view-item-image" src="{{itemThumbUrl}}" alt="{{itemTitle}}"></a>' +
		'</div>',

	'addToCardAction': '<div class="grid-view-item-addcart-wrapper">' +
		'<form method="post" action="/cart/add">' +
		'<input type="hidden" name="id" value="{{itemVariantsId}}" />' +
		'<input type="hidden" id="quantity" name="quantity" value="1"/>' +
		'<button class="cart-add-btn">Add to Cart</button>' +
		'</form>' +
		'</div>',
  
    'orderByPhoneAction' : '<div class="grid-view-item-addcart-wrapper"><a href="#orderphone-popup" class="cart-add-btn open-modal">Order by phone</a></div>',

	'enquireNowAction': 'Enquire Now',

	'collectionCtaPanel': '<div class="grid__item grid-item-cta">' +
		'<div class="grid-view-item" style="background-image: url({{ctaBackground}});">' +
		'<div class="grid-view-cta-content-wrapper">' +
		'<h2 role="heading" aria-level="2" class="grid-view-cta-title">{{ctaTitle}}</h2>' +
		'<p class="grid-view-cta-text">{{ctaDescription}}</p>' +
		'<div class="grid-view-cta-button">' +
		'<a role="link" class="grid-view-cta-button-link" href="{{ctaButtonLink}}"><span>{{ctaButtonText}}</span></a>' +
		'</div>' +
		'</div>' +
		'</div>' +
		'</div>',

	// Grid Template
	'vendorGridHtml': '<div class="grid-view-item__vendor">{{itemVendorLabel}}</div>',
	'soldOutLabelGridHtml': '<span class="product-price__sold-out">' + boostPFSThemeConfig.label.sold_out + '</span>',
	'productGridItemHtml': '<div class="grid__item small--one-half medium-up--one-quarter">' +
		'<div class="grid-view-item">' +
		'<script class="bc-sf-filter-product-script" data-id="bc-product-json-{{itemId}}" type="application/json">{{itemJson}}</script>' +
		'<div class="grid-view-item-wishlist-wrapper">' +
		'<span class="grid-view-item-wishlist-icon smartwishlist" data-product="{{itemId}}" data-variant="{{itemVariantsId}}"></span>' +
		'</div>' +
		'{{images}}' +
		'<div class="grid-view-item-meta">' +
		'<label class="grid-item-status {{orderStatus}}">{{orderStatusLabel}}</label>' +
		'<div class="h4 grid-view-item-title">{{itemTitle}}</div>' +
		'<div class="grid-view-item-price-wrapper">{{itemPrice}}</div>' +
		'<div class="grid-view-item-actions-wrapper">' +
		'{{addToCardAction}}' +
		'<div class="grid-view-item-enquire-wrapper">' +
		'<a class="open-popup grid-view-item-enquire-link" href="#product-enquire-popup" title="Enquire about \'{{itemTitle}}\'" data-product-id="{{itemId}}" data-product-title="{{itemTitle}}" data-product-variant="{{itemVariantsTitle}}" data-product-url="{{itemUrl}}">' +
		'{{enquireNowAction}}' +
		'</a>' +
		'</div>' +
		'</div>' +
		'<div class="grid-view-item-details-wrapper">' +
		'<a  class="grid-view-item-details-link" href="{{itemUrl}}" title="View {{itemTitle}} Details">' +
		'<span class="chevron">View Product Details</span>' +
		'</a>' +
		'</div>' +
		'</div>' +
		'</div>' +
		'</div>',

	// List Template
	'vendorSmallListHtml': '<div class="list-view-item__vendor-column small--hide"><div class="list-view-item__vendor">{{itemVendorLabel}}</div></div>',
	'vendorMediumListHtml': '<div class="list-view-item__vendor medium-up--hide">{{itemVendorLabel}}</div>',
	'saleLabelListHtml': '<div class="list-view-item__on-sale">' + boostPFSThemeConfig.label.sale + '</div>',
	'soldOutLabelListHtml': '<div class="list-view-item__sold-out">' + boostPFSThemeConfig.label.sold_out + '</div>',
	'productListItemHtml':  '<a href="{{itemUrl}}" class="list-view-item">' +
		'<div class="list-view-item__image-column">' +
		'<div class="list-view-item__image-wrapper">' +
		'<img class="list-view-item__image" src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
		'</div>' +
		'</div>' +
		'<div class="list-view-item__title-column">' +
		'<div class="list-view-item__title">{{itemTitle}}</div>' +
		'{{itemSaleLabel}}' +
		'{{itemMediumVendor}}' +
		'{{itemSoldOutLabel}}' +
		'</div>' +
		'{{itemSmallVendor}}' +
		'<div class="list-view-item__price-column">{{itemPrice}}</div>' +
		'</a>',

	// Pagination Template
	'previousActiveHtml': '<li><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow prev">« <span>Previous</span></a></li>',
	'previousDisabledHtml': '<li><div class="btn btn--secondary btn--narrow btn--disabled"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-left" viewBox="0 0 20 8"><path d="M4.814 7.555C3.95 6.61 3.2 5.893 2.568 5.4 1.937 4.91 1.341 4.544.781 4.303v-.44a9.933 9.933 0 0 0 1.875-1.196c.606-.485 1.328-1.196 2.168-2.134h.752c-.612 1.309-1.253 2.315-1.924 3.018H19.23v.986H3.652c.495.632.84 1.1 1.036 1.406.195.306.485.843.869 1.612h-.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Previous</span></div></li>',
	'nextActiveHtml': '<li><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow next"><span>Next</span> »</a></li>',
	'nextDisabledHtml': '<li><div class="btn btn--secondary btn--narrow btn--disabled"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-right" viewBox="0 0 20 8"><path d="M15.186.445c.865.944 1.614 1.662 2.246 2.154.631.491 1.227.857 1.787 1.098v.44a9.933 9.933 0 0 0-1.875 1.196c-.606.485-1.328 1.196-2.168 2.134h-.752c.612-1.309 1.253-2.315 1.924-3.018H.77v-.986h15.577c-.495-.632-.84-1.1-1.035-1.406-.196-.306-.486-.843-.87-1.612h.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Next</span></div></li>',
	'paginateHtml': '<ul class="list--inline pagination clearfix">{{previous}}{{pageItems}}{{next}}</ul>',

	// Sorting Template
	'sortingHtml': '<label for="boost-pfs-filter-top-sorting-select" class="label--hidden">' + '{{sortingLabel}}' + '</label><select id="boost-pfs-filter-top-sorting-select" class="filters-toolbar__input filters-toolbar__input--sort">{{sortingItems}}</select>',
};

(function(){
	BoostPFS.inject(this);

	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}

		var product_has_options = 0;
		data.options_with_values.forEach(function(option) {
			if (option.values.length > 1) product_has_options = 1;
		});
		if (data.type == "Ring") {
			product_has_options = 1;
		}

        // Check if any variant has a product quantity greater then 0
        let product_variants = data.variants;
        let product_available = false;

        for(let i = 0; i < product_variants.length; i++){
          if(product_variants[i].inventory_quantity > 0) product_available = true;
        }
      
        // Determine if it is POA
        product_is_poa = false;
        if($.inArray('Price:POA', data.tags) >= 0 || data.price_min == 0 ){
			product_is_poa = true;
		}
      
		//Adjust data.price_min to use lowest value above 0
		for (var i = 0; i < data['variants'].length; i++) {
			if(data.price_min == 0) {
				data.price_min = data['variants'][i].price;
			}
			else {
				if(data['variants'][i].price > 0 && data['variants'][i].price < data.price_min) {
					data.price_min = data['variants'][i].price;
				}
			}
		}
		/*** End Prepare data ***/
    
    

			// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		var oneImageHTML = boostPFSTemplate.oneImage;
		var multiImagesWrapperHTML = boostPFSTemplate.multiImagesWrapper;
		var multiImagesItemHTML = boostPFSTemplate.multiImagesItem;
		var addToCardAction = boostPFSTemplate.addToCardAction;
		var enquireNowAction = boostPFSTemplate.enquireNowAction;
        var orderByPhoneAction = boostPFSTemplate.orderByPhoneAction;

        if(data.price_min >= 10000 && !product_is_poa) {
          itemHtml = itemHtml.replace(/{{addToCardAction}}/g, orderByPhoneAction);
        }
        else {
		  itemHtml = itemHtml.replace(/{{addToCardAction}}/g, (product_has_options || product_is_poa || !product_available ? "" : addToCardAction));
        }

		//itemHtml = itemHtml.replace(/{{addToCardAction}}/g, (product_has_options || product_is_poa ? "" : addToCardAction));
		itemHtml = itemHtml.replace(/{{addToCardAction}}/g, (product_has_options || product_is_poa || !product_available ? "" : addToCardAction));
    
        itemHtml = itemHtml.replace(/{{itemVariantsId}}/g, data.variants[0].id);

		// Add Enquire now action
		itemHtml = itemHtml.replace(/{{enquireNowAction}}/g, (product_has_options || product_is_poa ? "Enquire" : enquireNowAction));

		// Add soldOut class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		// Add onSale class
		var onSaleClass = onSale ? boostPFSTemplate.onSaleClass : '';
		itemHtml = itemHtml.replace(/{{onSaleClass}}/g, onSaleClass);

		// Add soldOut item
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		// Add Thumbnail
		var imagesHtml = "";
		if (images.length <= 1) {
			var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '600x600') : boostPFSAppConfig.general.no_image_url;
			imagesHtml = oneImageHTML.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
		} else {
			var imageItems = "";
			images.forEach(function(image, index) {
				imageItems += multiImagesItemHTML.replace(/{{itemThumbUrl}}/g, Utils.optimizeImage(images[index]['src'], '600x600'));
			}.bind(this));
			imagesHtml = multiImagesWrapperHTML.replace(/{{multiImages}}/g, imageItems);
		}


		itemHtml = itemHtml.replace(/{{images}}/g, imagesHtml);

		var itemUrlHtml = Utils.buildProductItemUrl(data);
		if (Globals.queryParams.hasOwnProperty('pf_opt_precious_metal') && Globals.queryParams.pf_opt_precious_metal.length == 1) {
			var selectedColor = Globals.queryParams.pf_opt_precious_metal[0];
			var options = data.options_with_values.filter(function (e) {
				return (e.name).toLowerCase() == 'precious_metal';
			});
			if (typeof options[0] !== undefined) {
				// Set Url with variant
				var matchVariant = data.variants.filter(function (e) {
					if (e.title.toLowerCase().indexOf(selectedColor.toLowerCase()) !== -1) {
						return true;
					}
				});
				if (typeof matchVariant[0] !== undefined && typeof matchVariant[0]['id'] !== undefined && matchVariant[0]['id'] !== null) {
					itemUrlHtml = itemUrlHtml + '?variant=' + matchVariant[0]['id'];
				}
			}
		}
		var itemThumbUrlPop = itemUrlHtml;
		itemHtml = itemHtml.replace(/{{itemThumbUrlPop}}/g, itemThumbUrlPop);

		// Add Vendor
		var itemVendorHtml = boostPFSThemeConfig.custom.vendor_enable ? boostPFSTemplate.vendorGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Price
		var itemPriceHtml = '';
		if (onSale) {
          
			if (priceVaries) {
              
                if($.inArray('Price:POA', data.tags) >= 0 || data.price_min == 0 ){
					itemPriceHtml += '<span class="product__price">POA</span>';
				}
				else {
                    itemPriceHtml += '<span class="visually-hidden">' + boostPFSThemeConfig.label.regular_price + '</span>';
                    itemPriceHtml += '<s class="product-price__price">' + boostPFSThemeConfig.label.from + ' ' + Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat) +'</s>';
                    itemPriceHtml += ' <span class="product-price__price product-price__sale">';
                    itemPriceHtml += '<span class="product__price">' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + '</span>';
                    itemPriceHtml += ' <span class="product-price__sale-label">' + boostPFSThemeConfig.label.sale + '</span>';
                    itemPriceHtml += '</span>';
				}
			} 
            else {
                if($.inArray('Price:POA', data.tags) >= 0 || data.price_min == 0 ){
					itemPriceHtml += '<span class="product__price">POA</span>';
				}
				else {
    				itemPriceHtml += '<span class="visually-hidden">' + boostPFSThemeConfig.label.regular_price + '</span>';
    				itemPriceHtml += '<s class="product-price__price">' + Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat) + '</span></s>';
    				itemPriceHtml += ' <span class="product-price__price product-price__sale">';
    				itemPriceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
    				itemPriceHtml += ' <span class="product-price__sale-label">' + boostPFSThemeConfig.label.sale + '</span>';
    				itemPriceHtml += '</span>';
				}
			}
		} else {

			if (priceVaries) {
              
				if($.inArray('Price:POA', data.tags) >= 0 || data.price_min == 0 ){
					itemPriceHtml += '<span class="product__price">POA</span>';
				}
				else {
                    itemPriceHtml += '<span class="product__price">' + boostPFSFilterConfig.label.from + ' ' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + '</span>';
				}
            
			} else {              
				if($.inArray('Price:POA', data.tags) >= 0 || data.price_min == 0 ){
					itemPriceHtml += '<span class="product__price">POA</span>';
				}
				else {
					itemPriceHtml += '<span class="visually-hidden">' + boostPFSThemeConfig.label.regular_price + '</span>';
					itemPriceHtml += '<span class="product-price__price">' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + '</span>';
				}

			}

		}
      
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

		var description = '';
      
		if (data.description) {
        	description = (description.length > 150) ? description.substring(0, 140) + '...' : data.description;
		}
      
		itemHtml = itemHtml.replace(/{{itemDescription}}/g, description);

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVariantsTitle}}/g, data.variants[0].option_title)
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		// Set product status
		itemHtml = (product_available) ? itemHtml.replace(/{{orderStatus}}/g, 'ship') : itemHtml.replace(/{{orderStatus}}/g, 'order');
		itemHtml = (product_available) ? itemHtml.replace(/{{orderStatusLabel}}/g, 'In Stock') : itemHtml.replace(/{{orderStatusLabel}}/g, 'Made to order');

		return itemHtml;
	}

	// Build Image style
	function buildImageStyle(data) {
		var images = data.images_info;
		var imgId = 'ProductCardImage-'+ data.id;
		var wrapperId = 'ProductCardImageWrapper-'+ data.id;
		var imageStyle = '';
		if (images.length > 0) {
			var image = images[0];
			var width = boostPFSThemeConfig.custom.max_height;
			var height = boostPFSThemeConfig.custom.max_height;
			var aspect_ratio = image.width / image.height;
			var small_style = true;
			var container_aspect_ratio = width * 1.0 / height;

			if (image.aspect_ratio < 1.0) {
				var maximum_width = height * aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					maximum_width = image.width;
				} else {
					var maximum_height = height;
				}
			} else if (aspect_ratio < container_aspect_ratio) {
				var maximum_height = height / aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					var maximum_width = image.width;
				} else {
					var maximum_height = height;
					var maximum_width = height * aspect_ratio;
				}
			} else {
				var maximum_height = height / aspect_ratio;
				if (image.width <= width) {
					maximum_height = image.height;
					var maximum_width = image.width
				} else {
					var maximum_width = width;
					maximum_height = maximum_width / aspect_ratio;
				}
			}

			imageStyle += '<style>';
			if (small_style) imageStyle += '@media screen and (min-width: 750px) {';
			imageStyle += '#' + imgId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}' +
				'#' + wrapperId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}';
			if (small_style) imageStyle += '}';

			if (small_style) {
				if (aspect_ratio < 1) {
					maximum_width = 750 * aspect_ratio;
				} else {
					if (image.width < 750) {
						maximum_width = image.width;
					} else {
						maximum_width = 750;
					}
				}
				imageStyle += '@media screen and (max-width: 749px) {'
				imageStyle += '#' + imgId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'max-height: 750px;' +
					'}' +
					'#' + wrapperId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'}';
				imageStyle += '}';
			}
			imageStyle += '</style>';
		}
		return imageStyle;
	}

	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

			// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;

		// Add onSale label
		var itemSaleLabel = onSale ? boostPFSTemplate.saleLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '600x600') : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

		// Add Vendor
		var itemSmallVendorHtml = boostPFSThemeConfig.custom.vendor_enable ? boostPFSTemplate.vendorSmallListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
		var itemMediumVendorHtml = boostPFSThemeConfig.custom.vendor_enable ? boostPFSTemplate.vendorMediumListHtml : '';
		itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		// Set product status
		itemHtml = (data.available) ? itemHtml.replace(/{{orderStatus}}/g, 'ship') : itemHtml.replace(/{{orderStatus}}/g, 'order');
		itemHtml = (data.available) ? itemHtml.replace(/{{orderStatusLabel}}/g, 'In Stock') : itemHtml.replace(/{{orderStatusLabel}}/g, 'Made to order');

		return itemHtml;
	}

	function buildPrice(data, onSale, priceVaries) {
		var priceHtml = '',
			onSaleClass = onSale ? ' price--on-sale' : '';

		priceHtml += '<dl class="price' + onSaleClass + '" data-price>';
		if (boostPFSThemeConfig.custom.vendor_enable) {
			priceHtml += '<div class="price__vendor">';
			priceHtml += '<dt>';
			priceHtml += '<span class="visually-hidden">' + boostPFSThemeConfig.label.vendor + '</span>';
			priceHtml += '</dt>';
			priceHtml += '<dd>';
			priceHtml += data.vendor;
			priceHtml += '</dd>';
			priceHtml += '</div>';
		}
		priceHtml += '<div class="price__regular">';
		priceHtml += '<dt>';
		priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSThemeConfig.label.regular_price + '</span>';
		priceHtml += '</dt>';
		priceHtml += '<dd>';
		priceHtml += '<span class="price-item price-item--regular" data-regular-price>';
		if (data.available) {
			if (onSale) {
				priceHtml += Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat);
			} else {
				priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
			}
		} else {
			priceHtml += boostPFSThemeConfig.label.sold_out;
		}
		priceHtml += '</span>';
		priceHtml += '</dd>';
		priceHtml += '</div>';
		priceHtml += '<div class="price__sale">';
		priceHtml += '<dt>';
		priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSThemeConfig.label.sale_price + '</span>';
		priceHtml += '</dt>';
		priceHtml += '<dd>';
		priceHtml += '<span class="price-item price-item--sale" data-sale-price>';
		priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
		priceHtml += '</span> ';
		priceHtml += '<span class="price-item__label" aria-hidden="true">' + boostPFSThemeConfig.label.sale + '</span>';
		priceHtml += '</dd>';
		priceHtml += '</div>';
		priceHtml += '</dl>';

		return priceHtml;
	}

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
	
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
	
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}
	
		// Start building the pagination HTML
		var paginationHtml = boostPFSTemplate.paginateHtml;
	
		// Build Previous button
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
	
		// Build Numbered Pages
		var maxPagesToShow = 3; // Adjust this value based on your preference
		var startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
		var endPage = Math.min(totalPage, startPage + maxPagesToShow - 1);
	
		var pageItemsHtml = "";
	
		if (startPage > 1) {
			pageItemsHtml += '<li><a href="' + Utils.buildToolbarLink('page', currentPage, 1) + '" class="btn btn--secondary btn--narrow">1</a></li>';
			if (startPage > 2) {
				pageItemsHtml += '<li><a class="ellipsis btn btn--secondary btn--narrow">...</a></li>';
			}
		}
	
		for (var i = startPage; i <= endPage; i++) {
			var pageClass = (i === currentPage) ? ' current' : ''; // Add 'current' class if it's the current page
			var pageHtml = '<li><a href="' + Utils.buildToolbarLink('page', currentPage, i) + '" class="btn btn--secondary btn--narrow' + pageClass + '">' + i + '</a></li>';
			pageItemsHtml += pageHtml;
		}
	
		if (endPage < totalPage) {
			if (endPage < totalPage - 1) {
				pageItemsHtml += '<li><a class="ellipsis btn btn--secondary btn--narrow">...</a></li>';
			}
			pageItemsHtml += '<li><a href="' + Utils.buildToolbarLink('page', currentPage, totalPage) + '" class="btn btn--secondary btn--narrow">' + totalPage + '</a></li>';
		}
	
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
	
		// Build Next button
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
	
		// Close the pagination HTML
		paginationHtml += '</ul>';
	
		return paginationHtml;
	};
	

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml).replace(/{{sortingLabel}}/g, Labels.sorting);
			}
		}
		return html;
	};

	// Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>View As </span>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {

		// Reload custom behaviours
		if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)) ReloadSmartWishlist();
		if (typeof linneysActivateProductGrid !== "undefined" && $.isFunction(linneysActivateProductGrid)) linneysActivateProductGrid();
		if (typeof linneysInitialiseMagnific !== "undefined" && $.isFunction(linneysInitialiseMagnific)) linneysInitialiseMagnific();

		setTimeout(function() {
			$('#bc-sf-filter-products').css('min-height', $('#bc-sf-filter-products').height() + 'px')
		}, 1000);

		// Scroll back to top of product list
		$target = $(".collection-header");
		if ($target.length == 0) $(".section-header");
		if ($target.length > 0) {
			$([document.documentElement, document.body]).animate({
				scrollTop: $(".collection-header").first().offset().top - $('#shopify-section-header').height()
			}, 500);
		}

		// Initialise the filter bar
		if (typeof initialiseFilterBar !== "undefined" && $.isFunction(initialiseFilterBar)) initialiseFilterBar();
		// Add the collection CTA panel
		var currentPage = parseInt(Globals.queryParams.page);

		if (Globals.queryParams._ === 'pf' && !(currentPage > 1) && typeof collectionCta !== "undefined") {
			let ctaPanel = boostPFSTemplate.collectionCtaPanel;
			ctaPanel = ctaPanel.replace(/{{ctaTitle}}/g, collectionCta['ctaTitle']);
			ctaPanel = ctaPanel.replace(/{{ctaBackground}}/g, collectionCta['ctaBackground']);
			ctaPanel = ctaPanel.replace(/{{ctaDescription}}/g, collectionCta['ctaDescription']);
			ctaPanel = ctaPanel.replace(/{{ctaButtonText}}/g, collectionCta['ctaButtonText']);
			ctaPanel = ctaPanel.replace(/{{ctaButtonLink}}/g, collectionCta['ctaButtonLink']);
			$('#bc-sf-filter-products').append($(ctaPanel));
		}
	};

	// Build Additional Elements
	FilterResult.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		var totalProduct = '';
		if (data.total_product == 1) {
			totalProduct = boostPFSThemeConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
		} else {
			totalProduct = boostPFSThemeConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
	}

	Filter.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;

		if (Utils.isMobile() && boostPFSFilterConfig.general.filterTreeMobileStyle == 'style1') {
			jQ('body').addClass('boost-pfs-filter-tree-open-body');
		}

		$('.bc-filter-button__apply').click(function() {
			$('.mfp-close').trigger('click');
		});

		if (Utils.checkExistFilterOptionParam()) {
			jQ('.bc-filter-button__clear').show().off('click').on('click', function(e){
				e.preventDefault();
				var currentFilterOptionIds = [];
				Object.keys(Globals.queryParams).forEach(queryParam => {
					if (queryParam.startsWith(Globals.prefix)) {
						currentFilterOptionIds.push(queryParam);
					}
				});

				currentFilterOptionIds.forEach(filterOptionId => {
					FilterApi.setParam(filterOptionId, null);
				});
				FilterApi.setParam('page', 1);

				var eventType = 'clearAll';
				var eventInfo = {};
				FilterApi.applyFilter(eventType, eventInfo);
			});

		} else {
			jQ('.bc-filter-button__clear').hide();
		}
	};

	FilterTree.prototype.afterRender = function() {
		this.$element.find('.boost-pfs-filter-option-item-list.circle-grid').addClass('square-grid').removeClass('circle-grid');
		this.filterOptions.forEach(filterOption => {
			if (filterOption.filterItems.size < 1) {
				filterOption.$element.addClass('disable');
			}
		})
		if (this.filterTreeType == 'horizontal') {
			this.filterOptions.forEach(filterOption => {
				filterOption.$element.find('.boost-pfs-filter-option-title-heading').off('click')
			})
		}
	}

	FilterOption.prototype.isRender = function () {
		if (this.status == FilterOptionEnum.Status.ACTIVE) {
			// The setting name is "showSingleOption" but if set to "true", it will "Hide filter options with only one filter option value".
			var isHideFilterOptionWithOneValue = Settings.getSettingValue('general.showSingleOption');

			var numberFilterItems = 0;
			var isMultiLevel = this.displayType == FilterOptionEnum.DisplayType.MULTI_LEVEL_COLLECTIONS || this.displayType == FilterOptionEnum.DisplayType.MULTI_LEVEL_TAG;
			this.filterItems.forEach((filterItem) => {
				if (filterItem.$element && filterItem.$element.length) {
					numberFilterItems++;
					if (isMultiLevel && Array.isArray(filterItem.children) && filterItem.children.length > 0) {
						numberFilterItems += filterItem.children.length;
					}
				}
			})
			if (isHideFilterOptionWithOneValue) {
				return numberFilterItems > 1;
			} else {
				return true;
			}
		}
		return false;
	}
})();